import React,{useState} from 'react';
import HeaderBlack from '../component/Header/HeaderBlack';
import OwlCarousel from 'react-owl-carousel'; 
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';  



function MapBlack() {

    const options = {
        loop: true,
        margin: 10,
        nav: true,
        dots: true,
        autoplay: true,
        autoplayTimeout: 3000,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          1000: {
            items: 3
          }
        }
      };
  const [isOpen, setIsOpen] = useState(false);
  const [asOpen, setAsOpen] = useState(false);

  const openPopup = () => {
    setIsOpen(true);
  };

  const openAsPopup = () => {
    setAsOpen(true);
  };

  const closeAsPopup = () => {
    setAsOpen(false);
  };
  
  const closePopup = () => {
    setIsOpen(false);
  };    

  const [isVisible, setIsVisible] = useState(false);

  const [isVisibleing, setIsVisibleing] = useState(true);

  const [isVisibleings, setIsVisibleings] = useState(true);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const toggleVisibilities = () => {
    setIsVisibleing(!isVisibleing);
  };

  const toggleVisibilitis = () => {
    setIsVisibleings(!isVisibleings);
  };
  
    return (
      <>
      <HeaderBlack/>
      <section class="store-logo-main-content">
          <div class="container">
          <div class="row-dflex">
              <div class="col-1">
                  <h1>Modern AppForce</h1>
                  <span>Genboniya Tech</span>
                  <p class="vesion-text">9016.0 Latest Version</p>
                  <ul class="store-list-version-rating">
                      <li><a href="javascript:void(0)">
                          <small>4.9 <img src="assets/blacstar.svg" class="store-desktop-blackstar" alt="rating-img"/></small>
                          <p>1,000 reviews <img src="assets/rated-circle.svg" alt="rated-img"/></p></a>
                      </li>
                      <li><a href="javascript:void(0)">
                          <small>1k+</small>
                          <p>Downloads</p></a>
                      </li>
                      <li><a href="javascript:void(0)">
                          <small><img src="assets/threeplus.svg" class="rating-numbering" alt="icon-img"/></small>
                          <p>Rated for 3+  <img src="assets/rated-circle.svg" alt="rated-img"/></p></a>
                      </li>
                  </ul>
              </div>
              <div class="col-2">
                  <img src="https://wolfed.b-cdn.net/modernappforce/modern-appforce-logo.svg" class="store-main-logo" alt="logo-img"/>
                  <img src="https://wolfed.b-cdn.net/modernappforce/modern-appforce-logo.svg" class="store-main-mobile-logo" alt="logo-img"/>
              </div>
          </div>

          <div class="store-button-installing">
                      <a href="https://app.uka1.cc/modern-appforce-9016.0-web-release.apk" class="btn btn-store-install">Download</a>
                      <a href="javascript:void(0)" onClick={openPopup} class="btn btn-firestick-install">How To Install on Amazon Firestick Using Downloader App</a>
                      <a href="https://play.google.com/store/apps/details?id=com.appforcemodern.modernz" class="btn btn-firestick-install">Install From Play Store</a>
                      <a href="https://app.uka1.cc/ma.apk" class="btn btn-short-link">Apk Short Link</a>
                      <a style={{display:"none"}} href="javascript:void(0)" onClick={openAsPopup} class="btn btn-amazon-install">How To Install From Amazon App Store</a>
          </div>
                  {isOpen && (
        <div className="installing-vid" style={styles.overlay}>
          <div style={styles.popup}>
            <button style={styles.closeButton} onClick={closePopup}>X</button>
            <iframe
              width="500px"
              height="315"
              src="https://www.youtube.com/embed/GvwTQoLVYpA"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}

{asOpen && (
        <div className="installing-vid" style={styles.overlay}>
          <div style={styles.popup}>
            <button style={styles.closeButton} onClick={closeAsPopup}>X</button>
            <iframe
              width="500px"
              height="315"
              src="https://www.youtube.com/embed/5cC5Ft1XiXs"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}    
      
      <div class="store-mobile-list-version">
          <ul class="store-list-version-rating">
              <li class="store-mobile-list-review"><a href="javascript:void(0);">
                  <small>4.9 <img src="assets/blacstar.svg" alt="rating-img"/></small>
                  <p>1K reviews <img src="assets/rated-circle.svg" class="store-mobile-rateds" alt="rated-img"/></p></a>
              </li>
              <li>
                  <img src="assets/line-store.svg" height="30" alt="icon-img" style={{top: "-32px",position: "relative"}}/>
              </li>
              <li class="store-mobile-list-download"><a href="javascript:void(0);"> 
                  <small><img src="assets/download-app-icon.svg" class="store-mobile-download-icon" alt="app-icon"/></small>
                  <p>85.2 MB</p></a>
              </li>
              <li>
                  <img src="assets/line-store.svg" height="30" alt="icon-img" style={{top: "-32px",position: "relative"}}/>
              </li>
              <li class="store-mobile-list-plus"><a href="javascript:void(0);">
                  <small><img src="assets/threeplus.svg" class="rating-numbering store-mobile-download-icon" alt="icon-img"/></small>
                  <p>Rated for 3+  <img src="assets/rated-circle.svg" class="store-mobile-rateds" alt="rated-img"/></p></a>
              </li>
              <li>
                  <img src="assets/line-store.svg" height="30" alt="icon-img" style={{top: "-32px",position: "relative"}}/>
              </li>
              <li class="store-mobile-list-multiple-down"><a href="javascript:void(0)"> 
                  <small>10k+</small>
                  <p>Downloads</p></a>
              </li>
          </ul>
          <div class="store-install-button-mobile">
          <a href="https://app.uka1.cc/modern-appforce-9016.0-web-release.apk" class="btn-install-mobile">Download</a>
          <a href="javascript:void(0)" onClick={openPopup} class="btn btn-firestick-install">How To Install on Amazon Firestick Using Downloader App</a>
          <a style={{display:"none"}} href="javascript:void(0)" onClick={openAsPopup} class="btn btn-amazon-install">How To Install From Amazon App Store</a>
          <a href="https://play.google.com/store/apps/details?id=com.appforcemodern.modernz" class="btn btn-firestick-install">Install From Play Store</a>
          <a href="https://app.uka1.cc/ma.apk" class="btn btn-short-link">Apk Short Link</a>
      </div>
      </div>
      
      </div>
      </section>
      
      <section>
        <div className="container">
            <OwlCarousel className="owl-theme" {...options}>
               <div className="item"><img src="https://wolfed.b-cdn.net/modernappforce/modern-live-tv.webp" alt="modern appforce theme"/></div>
               <div className="item"><img src="https://wolfed.b-cdn.net/modernappforce/user-friendly.webp" alt="multi language"/></div>
               <div className="item"><img src="https://wolfed.b-cdn.net/modernappforce/power-your-playtime.webp" alt="parental control"/></div>
               <div className="item"><img src="https://wolfed.b-cdn.net/modernappforce/endlessapp.webp" alt="app password"/></div>
            </OwlCarousel>
        </div>
      </section>
      
      <section class="store-developing-section">
      <div class="container">
          <div class="row-dflex">
      
          <div class="store-main-content-detailing">
      
              <div class="col-about-1">
                  <div class="store-app-detail">
                      <h2>About this app</h2>
                      <p>Modern AppForce is a robust media player that provides user friendly features to fulfill your needs. In order to use Modern AppForce you need to add playlist of a service provider. We offer highly stylish and modern designs for the movie section. Now, you can customize your screen with just one touch.</p>
                      <p class="store-mb-0">
                      Modern AppForce is transforming your exposure to live entertainment with a highly intuitive interface. Contact Your services provider to watch your playlist. Start your journey with Modern AppForce Now!
                      </p>
                      <div class="store-about-detail-mobile">
                      {isVisible && (
                          <div class="store-about-more-detail-toggle">
                              <h4>Features</h4>
                      <ul class="store-about-feature-list">
                        <li><i class="fa fa-star"></i>&nbsp; Effortlessly customize Your Modern AppForce with one-time select audio language and subtitle language features. No need to change language every time.</li>
                        <li><i class="fa fa-star"></i>&nbsp; Customize the screen’s aspect ratio according to your convenience.</li>
                        <li><i class="fa fa-star"></i>&nbsp; Personalize your app settings using the Quick Utilities feature according to your ease.</li>
                          
                      </ul>   
                      <br/>
                      <h5>Note: </h5>
                      <ul class="store-about-feedback-list">
                          <li>① It is a video media player and does not offer channels or include any content. Please note, Modern AppForce PLAYER is not responsible for the content utilized within our app.</li>
                          <li>② The app offers a 3-day trial period for testing purposes. After this period, a license must be purchased to continue using the app.</li>
                          <li>③ Modern AppForce PLAYER does not sell playlists or subscriptions.</li> 
                          <li>④ Please be advised that there are no refunds after purchase.</li>
                      </ul> 
                      <p>We take your privacy very seriously, and please visit pages below for more details:</p>
                      <ul class="store-about-condition-list">
                          <li>➠ Privacy Policy</li>
                          <li>➠ Terms and Conditions</li>
                      </ul>    
                       </div>
                      )
                      } 
                      <a href="javascript:void(0)" id="store-show-about" onClick={toggleVisibility} 
                       class="store-about-more-detail">
                        {isVisible 
                          ? <>See Less <i className="fa fa-angle-up"></i></> 
                          : <>Read More <i className="fa fa-angle-down"></i></>}
                      </a>
                          <div class="store-about-tool-btn">
                          <a href="javascript:void(0);" class="store-about-tool">Tools</a>
                          </div>
                      </div>
                  </div>
              </div>
      
              <div class="col-xll-1">
                  <h2>What's New</h2>
                  <p class="store-last-update">Last updated on May 26, 2025</p>
                  <p class="store-regularly">            </p>
              </div>
      
              <div class="store-safety-heading">
                  <h2>Date Safety</h2>
                  <p>Safety starts with understanding how developers collect and share your data. 
                  Data privacy and security practices may vary based on your use, region, and age.
                   The developer provided this information and may update it over time.</p>
                   <p class="store-mobile-hide-security">
                      Security practices may vary based on your use, region, and age. The 
                      developer provided this information and may update it over time.
                  </p>
                   <a href="javascript:void(0)" id="store-show-safety" class="store-mobile-safety-more">Read More <i class="fa fa-angle-down"></i></a>
                   <a href="javascript:void(0)" id="store-hide-safety" class="store-mobile-safety-more">See Less <i class="fa fa-angle-up"></i></a>
              </div>
      
              
             <div class="store-security-content">
              <div class="store-security">
                  <div class="store-security-image">
                      <img src="assets/share-icon.svg" alt="safe-img"/>
                  </div>
                  <div class="store-security-text">
                      <p>This app may share these data types with third parties</p>
                      <p class="main-text">Location, Contacts and App activity</p>
                  </div>
              </div>
          
              <div class="store-security">
                  <div class="store-security-image">
                      <img src="assets/vector.svg" alt="safe-img"/>
                  </div>
                  <div class="store-security-text">
                      <p>This app may collect these data types</p>
                      <p class="main-text">Location, Personal info and 4 others</p>
                  </div>
              </div>
          
              <div class="store-security">
                  <div class="store-security-image">
                      <img src="assets/Lockicon.svg" class="store-lock-icon" alt="safe-img"/>
                  </div>
                  <div class="store-security-text">
                      <p>Data is encrypted in transit</p>
                  </div>
              </div>
          
              <div class="store-security">
                  <div class="store-security-image">
                      <img src="assets/Recycle-bin-icon.svg" alt="safe-img"/>
                  </div>
                  <div class="store-security-text">
                      <p>You can request that data be deleted</p>
                  </div>
              </div>
          
              <div class="store-date-saftey-content">
                  <div class="store-hide-safety">
                      <div class="store-security">
                           <div class="store-security-image">
                               <img src="assets/vector.svg" alt="safe-img"/>
                           </div>
                           <div class="store-security-text">
                               <p>This app may collect these data types</p>
                               <p class="main-text">Location, Personal info and 4 others</p>
                           </div>
                       </div>
                   </div>
               <a href="javascript:void(0)" id="store-show-detail" class="store-saftey-more">See detail <i class="fa fa-angle-down"></i></a>
               <a href="javascript:void(0)" id="store-hide-detail" class="store-saftey-more">See Less <i class="fa fa-angle-up"></i></a>
              </div>
          
             </div>
      
             <div class="col-review">
              <h3>Ratings and reviews</h3>
      <div class="review-box">
      <div class="rev-left">
          <h4>4.9</h4>
          <img src="assets/rating-stars.svg" width="" height="" class="start-rating" alt=""/>
          <p class="rating-update">1,000 reviews</p>
          <p class="mobile-rev-left">1,000 reviews</p>
      </div>
      <div class="rev-right">
          <div class="bar-main">
              <span>5</span><div class="bar"><div class="w3-light-grey w3-round-xlarge">
                      <div class="w3-container w3-blue w3-round-xlarge" style={{width:"51%"}}>&nbsp;</div>
                  </div></div></div>
          <div class="bar-main">
              <span>4</span><div class="bar"><div class="bar"><div class="w3-light-grey w3-round-xlarge">
                          <div class="w3-container w3-blue w3-round-xlarge" style={{width:"26%"}}>&nbsp;</div>
                      </div></div></div></div>
          <div class="bar-main">
              <span>3</span><div class="bar"><div class="bar"><div class="w3-light-grey w3-round-xlarge">
                          <div class="w3-container w3-blue w3-round-xlarge" style={{width:"10%"}}>&nbsp;</div>
                      </div></div></div></div>
          <div class="bar-main">
              <span>2</span><div class="bar"><div class="bar"><div class="w3-light-grey w3-round-xlarge">
                          <div class="w3-container w3-blue w3-round-xlarge" style={{width:"4%"}}>&nbsp;</div>
                      </div></div></div></div>
          <div class="bar-main">
              <span>1</span><div class="bar"><div class="bar"><div class="w3-light-grey w3-round-xlarge">
                          <div class="w3-container w3-blue w3-round-xlarge" style={{width:"10%"}}>&nbsp;</div>
                      </div></div></div></div>
      </div>
      </div>
      </div>
      
      <div class="store-person-detail-review">
          <div class="store-person-detail">
      
              <div class="store-person-cotent">
              <div class="store-person-img">
                  <img src="assets/user.svg" alt="icon-img"/>
              </div>
              <div class="store-person-title">
                  <span>Carina</span>
              </div>
              </div>
      
      
              <div class="store-person-dots">
                  <img src="assets/dot.svg" alt="icon-img"/>
              </div>
          </div>
      
      
      <div class="store-review-content">
          <div class="store-review-star">
              <ul>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
              </ul>
          </div>
          <div class="store-review-date">
              <span>27/05/2025</span>
          </div>
      </div>          
      <p class="review-text">I’ve been using Modern AppForce for a week now, and the streaming is consistently smooth—no more unexpected buffering during my favorite shows</p>
      </div>
      
      
      <div class="store-person-detail-review">
          <div class="store-person-detail">
      
              <div class="store-person-cotent">
              <div class="store-person-img">
                  <img src="assets/user.svg" alt="icon-img"/>
              </div>
              <div class="store-person-title">
                  <span>Nick Henry</span>
              </div>
              </div>
      
      
              <div class="store-person-dots">
                  <img src="assets/dot.svg" alt="icon-img"/>
              </div>
          </div>
      
      
      <div class="store-review-content">
          <div class="store-review-star">
              <ul>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
              </ul>
          </div>
          <div class="store-review-date">
              <span>01/06/2025</span>
          </div>
      </div>    
      
      <p class="review-text">It’s great to have all my apps organized in one place, and the 4K playback quality makes a difference on my TV.</p>
      </div>
      
      <div class="store-person-detail-review">
          <div class="store-person-detail">
      
              <div class="store-person-cotent">
              <div class="store-person-img">
                  <img src="assets/user.svg" alt="icon-img"/>
              </div>
              <div class="store-person-title">
                  <span>Bertha</span>
              </div>
              </div>
      
      
              <div class="store-person-dots">
                  <img src="assets/dot.svg" alt="icon-img"/>
              </div>
          </div>
      
      
      <div class="store-review-content">
          <div class="store-review-star">
              <ul>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
                  <li><img src="assets/star.svg" alt="star-img"/></li>
              </ul>
          </div>
          <div class="store-review-date">
              <span>04/06/2025</span>
          </div>
      </div>    
      
      <p class="review-text">The personalized themes and recommendations feel spot-on, and the interface is clean and easy to navigate. My go-to media player app!</p>
      </div>      
      
          </div>
      
          <div class="store-main-content-optioning">
      
              <div class="col-dev-1">
                  <div class="store-developing-content">
                      <h4>Developer Contact</h4>
                      <div class="store-developing-material">
                       <div class="store-developing-img">
                          <img src="assets/website-vector.svg" alt="icon-img"/>
                       </div>
                       <div class="store-developing-text store-developing-linking">
                          <h5>Website</h5>
                          <p><a href="https://modernappforce.com">https://modernappforce.com</a></p>
                       </div>
                      </div>
          
                      <div class="store-developing-material">
                          <div class="store-developing-img">
                             <img src="assets/Mail.svg" alt="icon-img"/>
                          </div>
                          <div class="store-developing-text store-developing-linking">
                             <h5>Email</h5>
                             <p><a href="mailto::info@modernappforce.com">info@modernappforce.com</a></p>
                          </div>
                         </div>
                         
                         <div class="store-developing-material store-mb-0">
                          <div class="store-developing-img">
                             <img src="assets/privacy.svg" alt="icon-img"/>
                          </div>
                          <div class="store-developing-text store-developing-linking">
                             <h5>Privacy Policy</h5>
                             <p><a href="https://modernappforce.com/privacy-policy">https://modernappforce.com/privacy-policy</a></p>
                          </div>
                         </div> 
          
                  </div>
              </div>
      
              <div class="col-xll-2">
                  <h4>App Info</h4>
                  <div class="store-app-info-vers">
                      <ul class="store-info-vserion-update">
                          <li>Current Version</li>
                          <li>Download Size</li>
                          <li>Update On</li>
                          <li>Downloads</li>
                          <li>Offered by</li>
                          <li>Release On</li>
                      </ul>
                      <ul class="store-info-vserion">
                          <li>9016.0</li>
                          <li>85.2MB</li>
                          <li>May 26, 2025</li>
                          <li>1k+ Downloads</li>
                          <li>Genboniya Tech</li>
                          <li>May 26, 2025</li>
                      </ul>
                  </div>
              </div>
      
          </div>
      
      
          </div>
      </div>
      
      </section>
      
      <section class="store-mobile-app-infos">
      
          <div class="col-xll-2">
          <div class="store-mobile-app-flex">
              <div class="store-mobile-app-heading"><h4>App Info</h4></div>
              <div class="store-mobile-app-icons" onClick={toggleVisibilities}> 
                {isVisibleing 
                          ? <><i className="fa fa-angle-up"></i></> 
                          : <><i className="fa fa-angle-down"></i></>}
              </div>
          </div>
              { isVisibleing && (
              <div class="store-app-info-vers">
                  <ul class="store-info-vserion-update">
                      <li>Current Version</li>
                      <li>Download Size</li>
                      <li>Update On</li>
                      <li>Downloads</li>
                      <li>Required OS</li>
                      <li>Offered by</li>
                      <li>Release On</li>
                  </ul>
                  <ul class="store-info-vserion">
                    <li>9016.0</li>
                    <li>85.2mb</li>
                    <li>May 26, 2025</li>
                    <li>10k+ Downloads</li>
                    <li>Genboniya Tech</li>
                    <li>May 26, 2025</li>
                  </ul>
              </div>
               )}
          </div>  
      
          <div class="col-dev-1">
              <div class="store-developing-content">
                  <div class="store-mobile-dev-flex">
                      <div class="store-mobile-dev-heading"><h4>Developer Contact</h4></div>
                      <div class="store-mobile-dev-icons"  onClick={toggleVisibilitis}> 
                           {isVisibleings 
                              ? <><i className="fa fa-angle-up"></i></> 
                              : <><i className="fa fa-angle-down"></i></>}
                      </div>
                  </div>

                  {isVisibleings && ( 
                   <div> 
                  <div class="store-developing-material">
                   <div class="store-developing-img">
                      <img src="assets/website-vector.svg" alt="icon-img"/>
                   </div>
                   <div class="store-developing-text">
                      <h5>Website</h5>
                      <p><a href="https://modernappforce.com/">https://modernappforce.com/</a></p>
                   </div>
                  </div>
      
                  <div class="store-developing-material">
                      <div class="store-developing-img">
                         <img src="assets/Mail.svg" alt="icon-img"/>
                      </div>
                      <div class="store-developing-text">
                         <h5>Email</h5>
                         <p><a href="to:info@modernappforce.com">info@modernappforce.com</a></p>
                      </div>
                     </div>
                     
                     <div class="store-developing-material store-mb-0">
                      <div class="store-developing-img">
                         <img src="assets/privacy.svg" alt="icon-img"/>
                      </div>
                      <div class="store-developing-text">
                         <h5>Privacy Policy</h5>
                         <p><a href="https://modernappforce.com/privacy-policy">https://modernappforce.com/privacy-policy</a></p>
                      </div>
                     </div>
                    </div>  
                    )} 
      
              </div>
          </div>
      
      </section>
      </>
      
    );
  }
const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  },
  popup: {
    position: 'relative',
    background: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.26)',
    maxWidth: '90%',
    maxHeight: '90%',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    border: 'none',
    background: '#000000',
    fontSize: '1.2rem',
    cursor: 'pointer',
    height: '40px',
    width: '40px',
    color: '#ffffff',
    borderRadius: '50%',
  }
};

export default MapBlack;